export const IMP_OCR = 'IMP_OCR';
export const IMP_EXCEL = 'IMP_EXCEL';
export const IMP_EXTERNAL = 'IMP_EXTERNAL';

export type ImpTypes = typeof IMP_OCR | typeof IMP_EXCEL | typeof IMP_EXTERNAL;